(ns client-portal.client.reports.components.day-parts-toggle-group
  (:require [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as time]
            [shared.core.util :as util]
            [client-portal.client.day-part-schedules.data]
            [client-portal.client.voice-insights.data :as vi.d]))

(defn day-parts-toggle-group [_]
  (let [selected-day-part- (re/subscribe [:voice-insights/selected-day-part-])]
    (re/create-class
      {:component-did-mount
       (fn [this]
         (when-let [dps (:data (re/props this))]
           (re/dispatch [:day-parts/set-list dps])))
       :reagent-render
       (fn [{:keys [data on-value-change]}]
         (when (and (not (util/loading? data)) (not-empty data))
           (let [day-parts (->> data
                                (sort-by :start-time)
                                (into [vi.d/day-part-all-day]))
                 label->day-part (->> day-parts
                                      (map (fn [{:keys [label] :as dp}] [label dp]))
                                      (into {}))
                 value (if (contains? label->day-part @selected-day-part-)
                         @selected-day-part-
                         (:label vi.d/day-part-all-day))]
             [alc/up-toggle-group
              {:type "single"
               :style {:display :flex
                       :flex-wrap :wrap
                       :height :auto
                       :padding 3}
               :value value
               :on-value-change (or on-value-change
                                    (fn [v]
                                      (when (seq v)
                                        (re/dispatch [:router/go-with-merged-query-params {:dp v}])
                                        (re/dispatch [:voice-insights/select-day-part v]))))
               :items (mapv (fn [{:keys [label start-time end-time]}]
                              {:value label
                               :content [:div {:style {:display :flex
                                                       :align-items :center
                                                       :gap 4}}
                                         [:span (util/capitalize-words label)]
                                         (when (and start-time end-time)
                                           [:span {:style {:color (style/alc-color "Text/secondary")
                                                           :font-size 10}}
                                            (str (time/reformat-date-str start-time "h:mm A")
                                                 " - "
                                                 (time/reformat-date-str end-time "h:mm A"))])]})
                            day-parts)}])))})))
